var exports = {
  "P": "x14bf3cd8--633a18--label",
  "L": "x14bf3cd8--633a18--valuation-label",
};

module.exports = exports;
